import { useNavigate } from "react-router-dom";
import { Box, Button, Card } from "@mui/material";
import MainContainer from "../../layout/MainContainer";
import useAuth from "../../hooks/useAuth";
import { sidebar } from "../auth/Login";
import { useEffect, useState } from "react";

const PermissionDenied = () => {
  const navigate = useNavigate();
  const user = useAuth()
  const [firstPermission,setFirstPermission] = useState("")
const firstCheckPermission = ()=>{
            const firstPermissionLabel = user?.accessRole?.permission.find(
              (item:any) => item.isView === true
            )?.label;
            const redirectPath = sidebar.find(
              (item) => item.label === firstPermissionLabel
            )?.path;
            setFirstPermission(redirectPath as string)
          }

  useEffect(()=>{
       firstCheckPermission()
  },[user])

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Insufficient Permissions</h1>
      </div>
      <Card className="cards_permssion">
        <Box className="cards_header">
          <Button className="btn btn_primary" onClick={() => navigate(firstPermission)}>
            Back
          </Button>
        </Box>
        <div className="no_permissions">
          <figure>
            <img src="/static/images/lock.png" alt="" />
          </figure>

          <p>
            You do not have necessary permissions required to access this view.
            For access please contact admin.
          </p>
        </div>
      </Card>
    </MainContainer>
  );
};

export default PermissionDenied;